import { render, staticRenderFns } from "./404.vue?vue&type=template&id=570de78e&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=570de78e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports